
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate3.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Gastrology Doctors',
      queryName: 'Gastrology',
      teamName: 'Gastrology team',
    };
  },
  components: { DoctorsList },
});
